import React from 'react';

import { AlertOutlined } from '@ant-design/icons';
import { IRouter } from '@routers/interface';
import { PermissionEnum } from '@modules/permissions/entity';

export const routerErrors: IRouter = {
  path: '/errors',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'errors.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  menu: {
    icon: <AlertOutlined />,
  },
  permissionCode: PermissionEnum.ErrorsView,
};
